import { render } from "./select-stock-destination.vue?vue&type=template&id=3fd5aad0"
import script from "./select-stock-destination.vue?vue&type=script&lang=js"
export * from "./select-stock-destination.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__